var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShapes = function SvgShapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 636 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.896 60.233v59.632l73.692 57.232 73.692-57.232V60.233L79.588 3 5.896 60.233Z",
    stroke: "#C6897B",
    strokeWidth: 3.685,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m405.772 181.071-56.191 56.19 142.972 142.971 142.971-142.971-54.734-54.734-88.43-88.237-86.588 86.781Zm86.594-81.57-83.989 84.175-53.585 53.585 137.761 137.76 137.76-137.76-52.128-52.128L492.366 99.5Z",
    fill: "#E2A723"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.042 362.709 45.609 68.079 45.609-68.079H4.042Z",
    stroke: "#81778C",
    strokeWidth: 3.685,
    fill: "#fff"
  })));
};
export default SvgShapes;